
export enum VATEX {
    /**
    * Exempt based on article 79, point c of Council Directive 2006/112/EC
    *
    * Repayment of expenditure is not an exemption in the sense of the VAT Directive but may be handled as such in the context of the EN16931.
    */
    ExemptBasedOnArticle79PointCCouncilDirective2006112Ec = "VATEX-EU-79-C",
    /**
    * Exempt based on article 132 of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132CouncilDirective2006112Ec = "VATEX-EU-132",
    /**
    * Exempt based on article 132, section 1 (a) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1ACouncilDirective2006112Ec = "VATEX-EU-132-1A",
    /**
    * Exempt based on article 132, section 1 (b) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1BCouncilDirective2006112Ec = "VATEX-EU-132-1B",
    /**
    * Exempt based on article 132, section 1 (c) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1CCouncilDirective2006112Ec = "VATEX-EU-132-1C",
    /**
    * Exempt based on article 132, section 1 (d) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1DCouncilDirective2006112Ec = "VATEX-EU-132-1D",
    /**
    * Exempt based on article 132, section 1 (e) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1ECouncilDirective2006112Ec = "VATEX-EU-132-1E",
    /**
    * Exempt based on article 132, section 1 (f) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1FCouncilDirective2006112Ec = "VATEX-EU-132-1F",
    /**
    * Exempt based on article 132, section 1 (g) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1GCouncilDirective2006112Ec = "VATEX-EU-132-1G",
    /**
    * Exempt based on article 132, section 1 (h) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1HCouncilDirective2006112Ec = "VATEX-EU-132-1H",
    /**
    * Exempt based on article 132, section 1 (i) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1ICouncilDirective2006112Ec = "VATEX-EU-132-1I",
    /**
    * Exempt based on article 132, section 1 (j) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1JCouncilDirective2006112Ec = "VATEX-EU-132-1J",
    /**
    * Exempt based on article 132, section 1 (k) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1KCouncilDirective2006112Ec = "VATEX-EU-132-1K",
    /**
    * Exempt based on article 132, section 1 (l) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1LCouncilDirective2006112Ec = "VATEX-EU-132-1L",
    /**
    * Exempt based on article 132, section 1 (m) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1MCouncilDirective2006112Ec = "VATEX-EU-132-1M",
    /**
    * Exempt based on article 132, section 1 (n) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1NCouncilDirective2006112Ec = "VATEX-EU-132-1N",
    /**
    * Exempt based on article 132, section 1 (o) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1OCouncilDirective2006112Ec = "VATEX-EU-132-1O",
    /**
    * Exempt based on article 132, section 1 (p) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1PCouncilDirective2006112Ec = "VATEX-EU-132-1P",
    /**
    * Exempt based on article 132, section 1 (q) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle132Section1QCouncilDirective2006112Ec = "VATEX-EU-132-1Q",
    /**
    * Exempt based on article 143 of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143CouncilDirective2006112Ec = "VATEX-EU-143",
    /**
    * Exempt based on article 143, section 1 (a) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1ACouncilDirective2006112Ec = "VATEX-EU-143-1A",
    /**
    * Exempt based on article 143, section 1 (b) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1BCouncilDirective2006112Ec = "VATEX-EU-143-1B",
    /**
    * Exempt based on article 143, section 1 (c) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1CCouncilDirective2006112Ec = "VATEX-EU-143-1C",
    /**
    * Exempt based on article 143, section 1 (d) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1DCouncilDirective2006112Ec = "VATEX-EU-143-1D",
    /**
    * Exempt based on article 143, section 1 (e) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1ECouncilDirective2006112Ec = "VATEX-EU-143-1E",
    /**
    * Exempt based on article 143, section 1 (f) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1FCouncilDirective2006112Ec = "VATEX-EU-143-1F",
    /**
    * Exempt based on article 143, section 1 (fa) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1FaCouncilDirective2006112Ec = "VATEX-EU-143-1FA",
    /**
    * Exempt based on article 143, section 1 (g) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1GCouncilDirective2006112Ec = "VATEX-EU-143-1G",
    /**
    * Exempt based on article 143, section 1 (h) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1HCouncilDirective2006112Ec = "VATEX-EU-143-1H",
    /**
    * Exempt based on article 143, section 1 (i) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1ICouncilDirective2006112Ec = "VATEX-EU-143-1I",
    /**
    * Exempt based on article 143, section 1 (j) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1JCouncilDirective2006112Ec = "VATEX-EU-143-1J",
    /**
    * Exempt based on article 143, section 1 (k) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1KCouncilDirective2006112Ec = "VATEX-EU-143-1K",
    /**
    * Exempt based on article 143, section 1 (l) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle143Section1LCouncilDirective2006112Ec = "VATEX-EU-143-1L",
    /**
    * Exempt based on article 144 of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle144CouncilDirective2006112Ec = "VATEX-EU-144",
    /**
    * Exempt based on article 146 section 1 (e) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle146Section1ECouncilDirective2006112Ec = "VATEX-EU-146-1E",
    /**
    * Exempt based on article 148 of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148CouncilDirective2006112Ec = "VATEX-EU-148",
    /**
    * Exempt based on article 148, section (a) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionACouncilDirective2006112Ec = "VATEX-EU-148-A",
    /**
    * Exempt based on article 148, section (b) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionBCouncilDirective2006112Ec = "VATEX-EU-148-B",
    /**
    * Exempt based on article 148, section (c) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionCCouncilDirective2006112Ec = "VATEX-EU-148-C",
    /**
    * Exempt based on article 148, section (d) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionDCouncilDirective2006112Ec = "VATEX-EU-148-D",
    /**
    * Exempt based on article 148, section (e) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionECouncilDirective2006112Ec = "VATEX-EU-148-E",
    /**
    * Exempt based on article 148, section (f) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionFCouncilDirective2006112Ec = "VATEX-EU-148-F",
    /**
    * Exempt based on article 148, section (g) of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle148SectionGCouncilDirective2006112Ec = "VATEX-EU-148-G",
    /**
    * Exempt based on article 151 of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle151CouncilDirective2006112Ec = "VATEX-EU-151",
    /**
    * Exempt based on article 151, section 1 (a) of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle151Section1ACouncilDirective2006112Ec = "VATEX-EU-151-1A",
    /**
    * Exempt based on article 151, section 1 (aa) of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle151Section1AaCouncilDirective2006112Ec = "VATEX-EU-151-1AA",
    /**
    * Exempt based on article 151, section 1 (b) of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle151Section1BCouncilDirective2006112Ec = "VATEX-EU-151-1B",
    /**
    * Exempt based on article 151, section 1 (c) of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle151Section1CCouncilDirective2006112Ec = "VATEX-EU-151-1C",
    /**
    * Exempt based on article 151, section 1 (d) of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle151Section1DCouncilDirective2006112Ec = "VATEX-EU-151-1D",
    /**
    * Exempt based on article 151, section 1 (e) of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle151Section1ECouncilDirective2006112Ec = "VATEX-EU-151-1E",
    /**
    * Exempt based on article 159 of Council Directive 2006/112/EC
    */
    ExemptBasedOnArticle159CouncilDirective2006112Ec = "VATEX-EU-159",
    /**
    * Exempt based on article 309 of Council Directive 2006/112/EC 
    */
    ExemptBasedOnArticle309CouncilDirective2006112Ec = "VATEX-EU-309",
    /**
    * Reverse charge
    *
    * Only use with VAT category code AE
    */
    ReverseCharge = "VATEX-EU-AE",
    /**
    * Travel agents VAT scheme.
    *
    * Only use with VAT category code E
    */
    TravelAgentsVatScheme = "VATEX-EU-D",
    /**
    * Second hand goods VAT scheme.
    *
    * Only use with VAT category code E
    */
    SecondHandGoodsVatScheme = "VATEX-EU-F",
    /**
    * Export outside the EU
    *
    * Only use with VAT category code G
    */
    ExportOutsideEu = "VATEX-EU-G",
    /**
    * Works of art VAT scheme.
    *
    * Only use with VAT category code E
    */
    WorksArtVatScheme = "VATEX-EU-I",
    /**
    * Intra-community supply
    *
    * Only use with VAT category code K
    */
    IntraCommunitySupply = "VATEX-EU-IC",
    /**
    * Collectors items and antiques VAT scheme.
    *
    * Only use with VAT category code E
    */
    CollectorsItemsAndAntiquesVatScheme = "VATEX-EU-J",
    /**
    * Not subject to VAT
    *
    * Only use with VAT category code O
    */
    NotSubjectToVat = "VATEX-EU-O",
    /**
    * France domestic VAT franchise in base
    *
    * For domestic invoicing in France
    */
    FranceDomesticVatFranchiseInBase = "VATEX-FR-FRANCHISE",
    /**
    * France domestic Credit Notes without VAT, due to supplier forfeit of VAT for discount
    *
    * For domestic Credit Notes only in France
    */
    FranceDomesticCreditNotesWithoutVatDueToSupplierForfeitVatForDiscount = "VATEX-FR-CNWVAT",
}

export function description(value: VATEX): string {
    switch (value) {
        case VATEX.ExemptBasedOnArticle79PointCCouncilDirective2006112Ec: return "Exempt based on article 79, point c of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132CouncilDirective2006112Ec: return "Exempt based on article 132 of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1ACouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (a) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1BCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (b) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1CCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (c) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1DCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (d) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1ECouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (e) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1FCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (f) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1GCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (g) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1HCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (h) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1ICouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (i) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1JCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (j) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1KCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (k) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1LCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (l) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1MCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (m) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1NCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (n) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1OCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (o) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1PCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (p) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle132Section1QCouncilDirective2006112Ec: return "Exempt based on article 132, section 1 (q) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143CouncilDirective2006112Ec: return "Exempt based on article 143 of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1ACouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (a) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1BCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (b) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1CCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (c) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1DCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (d) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1ECouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (e) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1FCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (f) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1FaCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (fa) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1GCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (g) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1HCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (h) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1ICouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (i) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1JCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (j) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1KCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (k) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle143Section1LCouncilDirective2006112Ec: return "Exempt based on article 143, section 1 (l) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle144CouncilDirective2006112Ec: return "Exempt based on article 144 of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle146Section1ECouncilDirective2006112Ec: return "Exempt based on article 146 section 1 (e) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148CouncilDirective2006112Ec: return "Exempt based on article 148 of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionACouncilDirective2006112Ec: return "Exempt based on article 148, section (a) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionBCouncilDirective2006112Ec: return "Exempt based on article 148, section (b) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionCCouncilDirective2006112Ec: return "Exempt based on article 148, section (c) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionDCouncilDirective2006112Ec: return "Exempt based on article 148, section (d) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionECouncilDirective2006112Ec: return "Exempt based on article 148, section (e) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionFCouncilDirective2006112Ec: return "Exempt based on article 148, section (f) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle148SectionGCouncilDirective2006112Ec: return "Exempt based on article 148, section (g) of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle151CouncilDirective2006112Ec: return "Exempt based on article 151 of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle151Section1ACouncilDirective2006112Ec: return "Exempt based on article 151, section 1 (a) of Council Directive 2006/112/EC ";
        case VATEX.ExemptBasedOnArticle151Section1AaCouncilDirective2006112Ec: return "Exempt based on article 151, section 1 (aa) of Council Directive 2006/112/EC ";
        case VATEX.ExemptBasedOnArticle151Section1BCouncilDirective2006112Ec: return "Exempt based on article 151, section 1 (b) of Council Directive 2006/112/EC ";
        case VATEX.ExemptBasedOnArticle151Section1CCouncilDirective2006112Ec: return "Exempt based on article 151, section 1 (c) of Council Directive 2006/112/EC ";
        case VATEX.ExemptBasedOnArticle151Section1DCouncilDirective2006112Ec: return "Exempt based on article 151, section 1 (d) of Council Directive 2006/112/EC ";
        case VATEX.ExemptBasedOnArticle151Section1ECouncilDirective2006112Ec: return "Exempt based on article 151, section 1 (e) of Council Directive 2006/112/EC ";
        case VATEX.ExemptBasedOnArticle159CouncilDirective2006112Ec: return "Exempt based on article 159 of Council Directive 2006/112/EC";
        case VATEX.ExemptBasedOnArticle309CouncilDirective2006112Ec: return "Exempt based on article 309 of Council Directive 2006/112/EC ";
        case VATEX.ReverseCharge: return "Reverse charge";
        case VATEX.TravelAgentsVatScheme: return "Travel agents VAT scheme.";
        case VATEX.SecondHandGoodsVatScheme: return "Second hand goods VAT scheme.";
        case VATEX.ExportOutsideEu: return "Export outside the EU";
        case VATEX.WorksArtVatScheme: return "Works of art VAT scheme.";
        case VATEX.IntraCommunitySupply: return "Intra-community supply";
        case VATEX.CollectorsItemsAndAntiquesVatScheme: return "Collectors items and antiques VAT scheme.";
        case VATEX.NotSubjectToVat: return "Not subject to VAT";
        case VATEX.FranceDomesticVatFranchiseInBase: return "France domestic VAT franchise in base";
        case VATEX.FranceDomesticCreditNotesWithoutVatDueToSupplierForfeitVatForDiscount: return "France domestic Credit Notes without VAT, due to supplier forfeit of VAT for discount";
    }
}
